import React, { FC, useEffect, useMemo, useState } from 'react';
import { Input, message, Radio } from 'antd';
import { api, endpoints } from '../../../../api';
import {
  BlueLayout,
  CloseBackground,
  CloseButton,
  CustomButton,
  PopupContainer,
  PopupUI,
} from '../../../../styles/styled';
import { StatusesType } from '../../../ApplicationPage/types';
import { RepresentativeType } from '../../types';

const { TextArea } = Input;
const RadioGroup = Radio.Group;
type StatusPopupProps = {
  representative: RepresentativeType;
  closePopup: () => void;
  statusesState: StatusesType;
};

export const StatusPopup: FC<StatusPopupProps> = ({ representative, closePopup, statusesState }) => {
  const [notConfirmedCheckBoxState, setNotConfirmedCheckbox] = useState<boolean>(true);
  const [rejectReasonState, setRejectReason] = useState<string | null>(null);
  const [refuseReasonState, setRefuseReason] = useState<string | null>(null);
  const [sendDataState, setData] = useState<boolean>(false);
  const representativeState = useMemo(() => {
    const code = representative.status.code;

    if (code === 'refused' || code === 'confirmed') {
      return { ...representative, status: statusesState?.find((el) => el.code === 'blocked') };
    } else if (code === 'not_confirmed')
      return notConfirmedCheckBoxState
        ? { ...representative, status: statusesState?.find((el) => el.code === 'confirmed') }
        : { ...representative, status: statusesState?.find((el) => el.code === 'refused') };
    else if (code === 'blocked')
      return { ...representative, status: statusesState?.find((el) => el.code === 'not_confirmed') };
  }, [notConfirmedCheckBoxState, representative, statusesState]);

  useEffect(() => {
    if (sendDataState) {
      (async () => {
        try {
          const response = await api.put(endpoints.representativeUpdate({ id: representative.id }), {
            status: { id: representativeState?.status?.id },
            reason_for_rejection: rejectReasonState || '',
            reason_for_refusal: refuseReasonState || '',
          });
          setData(false);
          closePopup();

          if (!response) message.error('Не удалось отправить данные');
        } catch (err) {
          message.error('Не удалось отправить данные');
          setData(false);
        }
      })();
    }
    // eslint-disable-next-line
  }, [sendDataState]);

  switch (representative.status.code) {
    case 'blocked':
      return (
        <PopupContainer>
          <CloseBackground onClick={() => closePopup()} />
          <PopupUI>
            <BlueLayout fontsize="25px">РАЗБЛОКИРОВАТЬ ПРЕДСТАВИТЕЛЯ ИЗДАТЕЛЬСТВ</BlueLayout>
            <TextArea value={refuseReasonState || ''} onChange={(e) => setRefuseReason(e.target.value)} rows={4} />
            <CustomButton onClick={() => setData(true)}>Сохранить</CustomButton>
            <CloseButton positioned onClick={() => closePopup()}>
              +
            </CloseButton>
          </PopupUI>
        </PopupContainer>
      );
    case 'refused':
    case 'confirmed':
      return (
        <PopupContainer>
          <CloseBackground onClick={() => closePopup()} />
          <PopupUI>
            <BlueLayout fontsize="25px">ЗАБЛОКИРОВАТЬ ПРЕДСТАВИТЕЛЯ ИЗДАТЕЛЬСТВ</BlueLayout>
            <TextArea value={refuseReasonState || ''} onChange={(e) => setRefuseReason(e.target.value)} rows={4} />
            <CustomButton onClick={() => setData(true)}>Сохранить</CustomButton>
            <CloseButton positioned onClick={() => closePopup()}>
              +
            </CloseButton>
          </PopupUI>
        </PopupContainer>
      );
    case 'not_confirmed':
      return (
        <PopupContainer>
          <CloseBackground onClick={() => closePopup()} />
          <PopupUI>
            <BlueLayout fontsize="25px">ОДОБРИТЬ КАНДИДАТУРУ ПРЕДСТАВИТЕЛЯ ИЗДАТЕЛЬСТВА</BlueLayout>
            <RadioGroup value={notConfirmedCheckBoxState} onChange={(e) => setNotConfirmedCheckbox(e.target.value)}>
              <Radio value={true}>Подтвердить</Radio>
              <Radio value={false}>Отклонить</Radio>
            </RadioGroup>
            {!notConfirmedCheckBoxState && (
              <TextArea value={rejectReasonState || ''} onChange={(e) => setRejectReason(e.target.value)} />
            )}
            <CustomButton onClick={() => setData(true)}>Сохранить</CustomButton>
            <CloseButton positioned onClick={() => closePopup()}>
              +
            </CloseButton>
          </PopupUI>
        </PopupContainer>
      );
    default:
      return (
        <PopupContainer>
          <CloseBackground onClick={() => closePopup()} />
          <PopupUI>
            <BlueLayout>В разработке</BlueLayout>
            <CloseButton style={{ position: 'absolute' }} positioned onClick={() => closePopup()}>
              +
            </CloseButton>
          </PopupUI>
        </PopupContainer>
      );
  }
};
